export default function wait(ms = 300) {
  return new Promise<void>((resolve) => {
    setTimeout(() => resolve(), ms);
  });
}
